//原生js的与dom操作帮助
import { throttle } from "./util";

interface IHelper {
    bindDrag: (dom: HTMLElement) => void;
    htmlOverflowHide: () => void;
    htmlOverflowAuto: () => void;
    getViewportWh: () => any;
}

const helper: IHelper = {
    bindDrag: (dom: HTMLElement) => {
        function getCss(ele: HTMLElement, prop: any) {
            return parseInt(window.getComputedStyle(ele)[prop]);
        }

        var isInDrag = false;
        var mX = 0;
        var mY = 0;
        var domStartX = 0, domStartY = 0;
        var domMaxY = document.documentElement.clientHeight
            - dom.offsetHeight;
        var domMaxX = document.documentElement.clientWidth
            - dom.offsetWidth;

        var panelHeader = $(dom).find(".card-header")[0];
        panelHeader.addEventListener("mousedown", (e: any) => {
            isInDrag = true;
            mX = e.clientX;
            mY = e.clientY;
            dom.style.position = "absolute";
            domStartX = getCss(dom, "left");
            domStartY = getCss(dom, "top");
        }, false);
        panelHeader.addEventListener("mouseup", (e: any) => {
            isInDrag = false;
            domStartX = getCss(dom, "left");
            domStartY = getCss(dom, "top");
        }, false);

        document.addEventListener("mousemove",
            throttle((e: any) => {

                if (isInDrag) {
                    var nowX = e.clientX,
                        nowY = e.clientY,
                        disX = nowX - mX,
                        disY = nowY - mY;
                    var newDomX = domStartX + disX;
                    var newDomY = domStartY + disY;
                    if (newDomX < 0) {
                        newDomX = 0;
                    } else if (newDomX > domMaxX) {
                        newDomX = domMaxX;
                    }
                    if (newDomY < 0) {
                        newDomY = 0;
                    } else if (newDomY > domMaxY) {
                        newDomY = domMaxY;
                    }

                    dom.style.left = newDomX + "px";
                    dom.style.top = newDomY + "px";
                }
            }, 100)
        );

        window.addEventListener("resize",
            throttle((e: any) => {
                domMaxY = document.documentElement.clientHeight
                    - dom.offsetHeight;
                domMaxX = document.documentElement.clientWidth
                    - dom.offsetWidth;
                domStartY = parseInt(dom.style.top);
                domStartX = parseInt(dom.style.left);
                if (domStartY > domMaxY) {
                    dom.style.top = domMaxY + "px";
                }

                if (domStartX > domMaxX) {
                    dom.style.left = domMaxX + "px";
                }
            }, 100),
            false);
    },
    htmlOverflowHide: () => {
        $("html").css("overflow", "hidden");
    },
    htmlOverflowAuto: () => {
        $("html").css("overflow", "auto");
    },
    getViewportWh: () => {
        let doc = document.documentElement;
        return {
            w: doc.clientWidth,
            h: doc.clientHeight
        }
    }
};

const fileHelper: any = {
    saveTextFile: (filename: string, fileContent: string) => {
        var link = document.createElement('a');
        link.download = filename;
        link.href = "data:text/plain;charset=utf-8," + encodeURIComponent(fileContent);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    saveFile: (filename: string, bytesBase64: string) => {
        var link = document.createElement('a');
        link.download = filename;
        link.href = "data:application/octet-stream;base64," + bytesBase64;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

export { helper, fileHelper };